module.exports = __webpack_public_path__ + "img/stock3.a535df1d.png";